import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Menu.module.scss";

import {
  Calculator,
  ChartNoAxesCombined,
  CircleUserRound,
  CreditCard,
  Crown,
  Gift,
  Heart,
  LayoutGrid,
  LogOut,
  MapPinHouse,
  PackageSearch,
  ShoppingCart,
  ShieldCheck,
  Store,
  TicketPercent,
} from "lucide-react";

import { useAuth } from "shared/contexts/Auth/AuthContext";
import BackgroundShape from "../backgroundshape/BackgroundShape";
import { featureFlags } from "shared/config/featureFlags";

interface MenuProps {
  handleClose: () => void;
}

export const Menu: React.FC<MenuProps> = ({ handleClose }) => {
  const navigate = useNavigate();

  const {
    user,
    perfilAtivo,
    setPerfilAtivo,
    isAdmin,
    isVendedor,
    logout,
  } = useAuth();

  /* DEBUG */
  useEffect(() => {
  }, [perfilAtivo]);

  async function handleLogout() {
    await logout();
    handleClose();
  }

  /* ================================
     ACESSAR ÁREA LOJISTA
  ================================ */

 function acessarAreaLojista() {
  setPerfilAtivo("vendedor");
  handleClose();
  navigate("/minhaslojas");
}
  /* ================================
     VOLTAR PARA CLIENTE
  ================================ */

  function acessarCliente() {
  setPerfilAtivo("comprador");
  handleClose();
  navigate("/minhaconta");
}

  function acessarAreaAdmin() {
    setPerfilAtivo("admin");
    handleClose();
    navigate("/admin/v2");
  }

  function acessarAreaLojistaFromAdmin() {
    setPerfilAtivo("vendedor");
    handleClose();
    navigate("/minhaslojas");
  }

  function acessarClienteFromAdmin() {
    setPerfilAtivo("comprador");
    handleClose();
    navigate("/minhaconta");
  }
  return (
    <div
      className={`${styles.menu} ${
        perfilAtivo === "vendedor"
          ? styles.menuVendedor
          : perfilAtivo === "admin"
            ? styles.menuAdmin
            : styles.menuComprador
      }`}
    >
      <div className={styles.menuContainer}>
        <BackgroundShape size={600} top={-100} right={-50} />
        <button  type="button"  className={styles.logoButton}
          onClick={() => { handleClose(); navigate("/", {state: {resetCategoria: true,refreshHome: Date.now(),},});}}>
          <img className={styles.logoEmpresa} src={ perfilAtivo === "vendedor"
          ? "/imagens/menuLogo.png" : "/imagens/menuLogoBranco.png"} alt="Logo"/>
        </button>

        {perfilAtivo === "vendedor" ? (
          <>
            <Link
              to="/minhaconta"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <CircleUserRound size={16} />
              <p>Minha Conta</p>
            </Link>

            <Link
              to="/minhaslojas"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <Store size={16} />
              <p>Minhas Lojas</p>
            </Link>

            <Link
              to="/meusprodutos"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <PackageSearch size={16} />
              <p>Meus Produtos</p>
            </Link>

            {featureFlags.checkout && (
              <>
                <Link
                  to="/minhasvendas"
                  className={styles.menuOption}
                  onClick={handleClose}
                >
                  <Calculator size={16} />
                  <p>Minhas Vendas</p>
                </Link>
                <Link
                  to="/relatorios"
                  className={styles.menuOption}
                  onClick={handleClose}
                >
                  <ChartNoAxesCombined size={16} />
                  <p>Relatórios</p>
                </Link>
              </>
            )}

            {/*<Link to="/meuscupons" className={styles.menuOption} onClick={handleClose}>
              <CreditCard size={16} />
              <p>Meus Cupons</p>
            </Link>*/}

            <button className={styles.menuOption} onClick={acessarCliente}>
              <Crown size={16} />
              <p>Acesso Cliente</p>
            </button>
            {isAdmin && (
              <button className={styles.menuOption} onClick={acessarAreaAdmin}>
                <ShieldCheck size={16} />
                <p>Acesso Admin</p>
              </button>
            )}
          </>
        ) : perfilAtivo === "admin" ? (
          <>
            <Link
              to="/minhaconta"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <CircleUserRound size={16} />
              <p>Minha Conta</p>
            </Link>

            <Link
              to="/admin/v2/variacoes"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <ShieldCheck size={16} />
              <p>Variações Globais</p>
            </Link>

            <button className={styles.menuOption} onClick={acessarClienteFromAdmin}>
              <Crown size={16} />
              <p>Acesso Cliente</p>
            </button>
            {isVendedor && (
              <button
                className={styles.menuOption}
                onClick={acessarAreaLojistaFromAdmin}
              >
                <Store size={16} />
                <p>Acesso Lojista</p>
              </button>
            )}
          </>
        ) : (
          <>
            <Link
              to="/minhaconta"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <CircleUserRound size={16} />
              <p>Minha Conta</p>
            </Link>

            {featureFlags.coupons && (
              <Link
                to="/cupons"
                className={styles.menuOption}
                onClick={handleClose}
              >
                <TicketPercent size={16} />
                <p>Cupons de Desconto</p>
              </Link>
            )}

            <Link
              to="/favoritos"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <Heart size={16} />
              <p>Meus Favoritos</p>
            </Link>
            {featureFlags.checkout && (
              <Link
                to="/minhascompras"
                className={styles.menuOption}
                onClick={handleClose}
              >
                <Gift size={16} />
                <p>Minhas Compras</p>
              </Link>
            )}

            <Link
              to="/carrinho"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <ShoppingCart size={16} />
              <p>Meu Carrinho</p>
            </Link>

            <Link
              to="/metodopagamento"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <CreditCard size={16} />
              <p>Método de Pagamento</p>
            </Link>

            <Link
              to="/categorias"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <LayoutGrid size={16} />
              <p>Categorias</p>
            </Link>

            <Link
              to="/meusenderecos"
              className={styles.menuOption}
              onClick={handleClose}
            >
              <MapPinHouse size={16} />
              <p>Meus Endereços</p>
            </Link>

            <button className={styles.menuOption} onClick={acessarAreaLojista}>
              <Store size={16} />
              <p>Acesso Lojista</p>
            </button>
            {isAdmin && (
              <button className={styles.menuOption} onClick={acessarAreaAdmin}>
                <ShieldCheck size={16} />
                <p>Acesso Admin</p>
              </button>
            )}
          </>
        )}
        {/*
        <Link to="/reportar" className={styles.menuOption} onClick={handleClose}>
          <TriangleAlert size={16} />
          <p>Suporte</p>
        </Link>

        {/*<Link to="/configuracoes" className={styles.menuOption} onClick={handleClose}>
         // <Settings size={16} />
         // <p>Configurações</p>
       //</Link>*/}
      </div>

      {user && (
        <button className={styles.menuSair} onClick={handleLogout}>
          <LogOut size={16} />
          <p>Sair da Conta</p>
        </button>
      )}
    </div>
  );
};
